import { AppDispatch } from 'src/store/Store';
import axios from '../../../utils/axios';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

// API of userList
const GATE_PASS_URL = `${process.env.REACT_APP_BASE_URL}/gate-pass/web/requests`;
const GATE_PASS_GET_BY_ID = `${process.env.REACT_APP_BASE_URL}/gate-pass/by-id`;

const localToken = process.env.REACT_APP_TOKEN!;
const getToken = () => localStorage.getItem(localToken);

interface GatePassListProps {
  data: any[];
  gatePassData: any[];
  status: boolean | null;
  message: string | null;
}

const initialState: GatePassListProps = {
  data: [],
  gatePassData: [],
  status: null,
  message: null,
};

export const GatePassSlice = createSlice({
  name: 'GatePassSlice',
  initialState,
  reducers: {
    // get user list
    gatePassListSuccess: (
      state,
      action: PayloadAction<{ data: any[]; status: boolean; message: string }>,
    ) => {
      state.data = action.payload.data;
      state.status = action.payload.status;
      state.message = action.payload.message;
    },
    gatePassListFailure: (state, action: PayloadAction<{ status: boolean; message: string }>) => {
      state.status = action.payload.status;
      state.message = action.payload.message;
    },

    // get User details
    gatePassDetailsSuccess: (
      state,
      action: PayloadAction<{ gatePassData: any[]; status: boolean; message: string }>,
    ) => {
      state.gatePassData = action.payload.gatePassData;
      state.status = action.payload.status;
      state.message = action.payload.message;
    },
    gatePassDetailsFailure: (
      state,
      action: PayloadAction<{ status: boolean; message: string }>,
    ) => {
      state.status = action.payload.status;
      state.message = action.payload.message;
    },
  },
});

export const {
  gatePassListSuccess,
  gatePassListFailure,
  gatePassDetailsSuccess,
  gatePassDetailsFailure,
} = GatePassSlice.actions;

export const fetchGatePassList =
  (page: number, rowsPerPage: number, search: string) => async (dispatch: AppDispatch) => {
    const token = getToken();
    let api_url = `${GATE_PASS_URL}?page=${page}&limit=${rowsPerPage}`;

    if (search) {
      api_url = `${api_url}&search=${search}`;
    }

    try {
      const response = await axios.get(api_url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(
        gatePassListSuccess({
          status: response.data.status,
          message: response.data.message,
          data: response.data.data,
        }),
      );

      return response;
    } catch (error: any) {
      dispatch(
        gatePassListFailure({
          status: false,
          message: error.message,
        }),
      );
      console.log(error);
    }
  };

export const getGatePassDetailById = (id: number) => async (dispatch: AppDispatch) => {
  let token = localStorage.getItem(localToken);
  if (token) {
    token = token;
  }
  try {
    const response = await axios.get(`${GATE_PASS_GET_BY_ID}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(
      gatePassDetailsSuccess({
        status: response.data.status,
        message: response.data.message,
        gatePassData: response.data.data,
      }),
    );

    return response;
  } catch (error: any) {
    dispatch(
      gatePassDetailsFailure({
        status: false,
        message: error.message,
      }),
    );
    console.log(error);
  }
};

export default GatePassSlice.reducer;
